import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import compose from 'recompose/compose'
import withHandlers from 'recompose/withHandlers'
import withState from 'recompose/withState'
import lifecycle from 'recompose/lifecycle'

import { PlaybookStatus } from 'app/modules/playbook/constants'
import * as PlaybookActions from 'app/modules/playbook/actions'
import * as PlaybookSelectors from 'app/modules/playbook/selectors'
import * as OrgSelectors from 'app/modules/org/selectors'

import PlaybookDraftToggle from './component'

const mapStateToProps = state => {
  const userListIds = PlaybookSelectors.userListIds(state)
  return {
    checked: PlaybookSelectors.isEnabled(state),
    isEmailPlaybook: PlaybookSelectors.getIsEmailPlaybook(state),
    isOutboundSequencePlaybook: PlaybookSelectors.getIsOutboundSequencePlaybook(state),
    userListIds,
    excludedUserListIds: PlaybookSelectors.excludedUserListIds(state),
    draft: PlaybookSelectors.draft(state),
    targetingCardinality: PlaybookSelectors.targetingCardinality(state),
    smartFilters: PlaybookSelectors.smartFilters(state),
    orgId: OrgSelectors.orgId(state),
    saved: PlaybookSelectors.isSaved(state),
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      setDraftStatus: PlaybookActions.setDraftStatus,
      setStatus: PlaybookActions.setStatus,
      fetchPlaybookCardinality: PlaybookActions.fetchPlaybookCardinality,
      showSendEmailConfirmModal: PlaybookActions.showSendEmailConfirmModal,
      enablePlaybookAutosave: PlaybookActions.enablePlaybookAutosave,
      disablePlaybookAutosave: PlaybookActions.disablePlaybookAutosave,
      showDisableSalesSequenceModal: PlaybookActions.showDisableSalesSequenceModal,
    },
    dispatch
  ),
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withState('defaultValue', 'setDefaultValue', false),
  lifecycle({
    componentDidMount() {
      const { userListIds, excludedUserListIds, orgId, smartFilters } = this.props
      if (!window.isFinite(this.props.targetingCardinality)) {
        this.props.actions.fetchPlaybookCardinality({ orgId, userListIds, excludedUserListIds, smartFilters })
      }
    }
  }),
  withHandlers({
    onChange: props => () => {
      const {
        disablePlaybookAutosave,
        enablePlaybookAutosave,
        setDraftStatus,
        showDisableSalesSequenceModal,
        showSendEmailConfirmModal,
      } = props.actions

      if (!props.saved && props.draft.status !== PlaybookStatus.ENABLED) {
        const wantsToEnable = confirm(`${props.isEmailPlaybook ? 'Send email' : 'Enable playbook'} without saving your changes?`)
        if (!wantsToEnable) {
          props.setDefaultValue(!props.defaultValue)
          return
        }
      }
      if (props.isEmailPlaybook && !props.isOutboundSequencePlaybook) {
        if (!props.checked) {
          props.setDefaultValue(false)
          showSendEmailConfirmModal()
        } else {
          setDraftStatus({ status: PlaybookStatus.DISABLED })
        }
      // Show DiableSalesSequenceModal if turning a Sales Sequence playbook off.
      } else if (props.isEmailPlaybook && props.isOutboundSequencePlaybook) {
        if (props.checked) {
          props.setDefaultValue(true)
          showDisableSalesSequenceModal()
        } else {
          setDraftStatus({ status: PlaybookStatus.ENABLED })
        }

      } else {
        const newStatus = props.draft.status === PlaybookStatus.ENABLED ? PlaybookStatus.DISABLED : PlaybookStatus.ENABLED
        if (newStatus === PlaybookStatus.ENABLED) {
          disablePlaybookAutosave()
        } else if (newStatus === PlaybookStatus.DISABLED) {
          enablePlaybookAutosave()
        }
        setDraftStatus({ status: newStatus })
      }
    },
  })
)(PlaybookDraftToggle)



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/PlaybookDraftToggle/index.js